import { createAsyncThunk } from '@reduxjs/toolkit';
import RootState from "../states/root.state";
import { getTubModels } from '../../services/api/tubModels.api';

export const fetchTubModels = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
    'tubModels',
    async (params, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;
            const response = await getTubModels(token, params);
            return response;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching tub models.");
            } else {
                return rejectWithValue('An error occurred while fetching tub models.');
            }
        }
    }
);